import {
  borderRadius,
  fontSize,
  fontWeight,
  mediaMax,
  mediaMin,
  spacing,
} from 'presentations/views/styles';
import styled from '@emotion/styled';
import Image from 'presentations/views/components/atoms/Image';
import Link from 'presentations/views/components/atoms/Link';
import Icon from 'presentations/views/components/atoms/Icon';
import { black, white } from 'presentations/views/styles/color';
import { ReactNode } from 'react';

interface Props {
  imageUrl?: string;
  imageWidth?: number;
  imageHeight?: number;
  title: string;
  description: string | ReactNode;
  link?: string;
  linkTitle?: string;
}

export default function Component(props: Props) {
  return (
    <Content>
      {props.imageUrl && (
        <ImageContent href={props.link}>
          <MainIcon
            src={props.imageUrl}
            width={props.imageWidth}
            height={props.imageHeight}
            alt={props.title}
          />
        </ImageContent>
      )}
      <MainContent>
        <TitleContainer>
          {props.link ? (
            <Link href={props.link}>
              <TitleText>{props.title}</TitleText>
            </Link>
          ) : (
            <TitleText>{props.title}</TitleText>
          )}
        </TitleContainer>
        <Description>{props.description}</Description>
        {props.link && props.linkTitle && (
          <DetailLink href={props.link}>
            <DetailIcon name="chevron-right" />
            {props.linkTitle}
          </DetailLink>
        )}
      </MainContent>
    </Content>
  );
}
const Content = styled.div`
  height: 100%;
  box-shadow: 0px 10px 30px rgba(102, 102, 102, 0.15);
  border-radius: ${borderRadius(16)};
  text-align: center;
  padding: ${spacing(32)};
  background-color: ${white};
  ${mediaMax.tablet} {
    width: auto;
  }
`;
const ImageContent = styled(Link)`
  margin-bottom: ${spacing(24)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${mediaMin.tablet} {
    min-height: 60px;
  }
`;
const MainIcon = styled(Image)``;
const MainContent = styled.div`
  margin-bottom: ${spacing(8)};
`;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: ${spacing(16)};
`;
const TitleText = styled.div`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(20)};
  color: ${black};
`;
const Description = styled.div`
  text-align: left;
`;

const DetailLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${fontSize(16)};
  color: ${black};
  margin-top: ${spacing(16)};
`;
const DetailIcon = styled(Icon)`
  width: 18px !important;
  height: 18px !important;
  color: ${black};
  margin-right: ${spacing(4)};
`;
